namespace GeniuzPOS.Administration {
    export enum PsParaGenTypeReceiptPrinterType {
        ReceiptPrinterType1 = 1,
        ReceiptPrinterType2 = 2
    }
    Serenity.Decorators.registerEnumType(PsParaGenTypeReceiptPrinterType, 'GeniuzPOS.Administration.PsParaGenTypeReceiptPrinterType', 'Administration.PsParaGenTypeReceiptPrinterType');
}
